import { AuthCallback } from './pages';

export default {
  key: 'auth-callback',
  path: '/auth/callback',
  exact: true,
  component: AuthCallback,
};
